import { cn } from 'noddi-ui-common';
import { KeyboardEvent, PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

type NoddiCardWrapperProps = {
  className?: string;
  onClick?: () => void;
  to?: string;
  disabled?: boolean;
  openInNewTab?: boolean;
  size?: 'default' | 'small';
};

export const NoddiBasicCard = ({
  children,
  className,
  onClick,
  to,
  disabled,
  openInNewTab,
  size = 'default'
}: PropsWithChildren<NoddiCardWrapperProps>) => {
  const cardClasses = cn(
    'rounded-2xl bg-white text-start shadow-sm',
    size === 'small' ? 'px-3 py-2' : 'px-5 py-4',
    (onClick || to) &&
      'transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-grey active:scale-95 md:hover:shadow-xl',
    className
  );

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      if (event.key === ' ') {
        event.preventDefault();
      }
      onClick();
    }
  };

  // Link (anchor tag) is only one with to prop, so render Link. ( It also has optional onClick prop)
  if (to) {
    return (
      <Link
        to={to}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noreferrer' : undefined}
        onClick={onClick}
        className={cardClasses}
      >
        {children}
      </Link>
    );
  }

  // Could consider making this with a button when onClick is present, but it would require a bit more work to get the styling? Also we get invalid dom nesting if we have buttons inside buttons, which we do from time to time, salesItemPicker etc..
  return (
    <div
      onClick={disabled ? undefined : onClick}
      role={onClick ? 'button' : undefined}
      onKeyDown={handleKeyDown}
      tabIndex={onClick ? 0 : undefined}
      aria-pressed={onClick ? 'false' : undefined}
      className={cardClasses}
    >
      {children}
    </div>
  );
};
